import { Dispatch, Middleware } from 'redux';
import type { RootState } from '@src/store/index';

export const SESSION_STATE_KEY = 'tef-coms-state';

export const loadState = () => {
  try {
    const serializedState = sessionStorage.getItem(SESSION_STATE_KEY);
    if (!serializedState) return undefined;
    const state = JSON.parse(serializedState) as RootState;
    // Reset some values for processing reasons...
    const { config, auth, consents } = state;
    auth.error = false;
    consents.error = false;
    config.error = false;
    config.occlThemeLoaded = false;
    config.occlVendorsLoaded = false;
    config.occlBundleLoaded = false;
    config.occlReady = false;
    return state;
    // eslint-disable-next-line sonarjs/no-ignored-exceptions
  } catch (_err) {
    return undefined;
  }
};

export const saveState = (state: RootState) => {
  const serializedState = JSON.stringify(state);
  sessionStorage.setItem(SESSION_STATE_KEY, serializedState);
};

export const persist: Middleware<unknown, RootState> = ({ getState }) => (next) => (action) => {
  const value = next(action) as Dispatch;
  const state = getState();
  saveState(state);
  return value;
};
